/**
 * Gang Sheet native exact-price cart contract.
 *
 * Every supported whole-inch length resolves to one allowlisted Shopify
 * variant. No Dollar/Cent or grouped adjustment line is constructed here.
 */
(function (root, factory) {
  var api = factory(root);

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.ZugDtfNativeCart = api;
  }
})(typeof window !== 'undefined' ? window : null, function (root) {
  'use strict';

  var CONTRACT = 'gang_sheet_native_regular_v1';
  var PRODUCT_ID = 6920034844735;
  var PRODUCT_HANDLE = 'gang-sheet-heat-transfers';
  var WIDTH_IN = 22;
  var MIN_LENGTH_IN = 12;
  var MAX_LENGTH_IN = 120;
  var VARIANT_COUNT = 109;
  var LEGACY_MARKERS = [
    'calc_line_uid',
    '_calc_line_uid',
    '_pricing_engine',
    '_line_type',
    '_dtf_exact_price_bundle',
    '_dtf_quantity_scalable',
    '_dtf_unit_total_cents',
    '_dtf_base_price_cents',
    '_dtf_bundle_role',
    '_dtf_adjustment_unit',
    '_dtf_quantity_per_sheet'
  ];

  function positiveInteger(value) {
    var number = Number(value);
    return Number.isInteger(number) && number > 0 ? number : null;
  }

  function validLength(value) {
    var number = Number(value);
    return Number.isInteger(number) && number >= MIN_LENGTH_IN && number <= MAX_LENGTH_IN ? number : null;
  }

  function pricePerSqIn(lengthIn) {
    if (lengthIn <= 12) return 0.07;
    if (lengthIn <= 24) return 0.05;
    if (lengthIn <= 36) return 0.045;
    if (lengthIn <= 48) return 0.04;
    if (lengthIn <= 72) return 0.035;
    return 0.03;
  }

  function priceCents(lengthIn) {
    var length = validLength(lengthIn);
    if (!length) return null;
    return Math.round(WIDTH_IN * length * pricePerSqIn(length) * 100);
  }

  function optionValue(lengthIn) {
    return WIDTH_IN + ' × ' + lengthIn + ' in';
  }

  function sku(lengthIn) {
    return 'GS-22X' + String(lengthIn).padStart(3, '0');
  }

  function createUid() {
    var randomPart = '';
    if (root && root.crypto && typeof root.crypto.randomUUID === 'function') {
      randomPart = root.crypto.randomUUID();
    } else {
      randomPart = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    }
    return 'gang-native-' + randomPart;
  }

  function validateMap(map) {
    var errors = [];
    var variants = map && map.variants;
    var keys = variants && typeof variants === 'object' ? Object.keys(variants) : [];

    if (!map || map.contract !== CONTRACT || Number(map.productId) !== PRODUCT_ID ||
        map.productHandle !== PRODUCT_HANDLE || Number(map.widthIn) !== WIDTH_IN ||
        Number(map.minLengthIn) !== MIN_LENGTH_IN || Number(map.maxLengthIn) !== MAX_LENGTH_IN ||
        Number(map.incrementIn) !== 1 || map.turnaround !== 'regular') {
      errors.push('native Gang Sheet catalog identity is invalid');
    }
    if (keys.length !== VARIANT_COUNT) {
      errors.push('native Gang Sheet catalog must contain exactly 109 variants');
    }

    for (var length = MIN_LENGTH_IN; length <= MAX_LENGTH_IN; length += 1) {
      var entry = variants && variants[String(length)];
      if (!entry || Number(entry.lengthIn) !== length || positiveInteger(entry.variantId) === null ||
          entry.sku !== sku(length) || entry.optionValue !== optionValue(length) ||
          Number(entry.priceCents) !== priceCents(length) || entry.available !== true ||
          entry.requiresShipping !== true || entry.inventoryTracked !== false ||
          entry.inventoryPolicy !== 'DENY' || entry.taxable !== true) {
        errors.push('native Gang Sheet variant mapping failed for length ' + length);
      }
    }

    return { valid: errors.length === 0, errors: errors };
  }

  function resolveVariant(map, lengthIn) {
    var length = validLength(lengthIn);
    if (!length) throw new Error('Gang Sheet length must be a whole number from 12 through 120 inches.');
    var validation = validateMap(map);
    if (!validation.valid) {
      throw new Error('Gang Sheet native catalog failed validation: ' + validation.errors.join('; '));
    }
    return map.variants[String(length)];
  }

  function stripLegacyMarkers(properties) {
    LEGACY_MARKERS.forEach(function (key) {
      delete properties[key];
    });
    return properties;
  }

  function addBogoProductionMetadata(properties) {
    if (properties._zug_dtf_builder) {
      var payload;
      try {
        payload = JSON.parse(properties._zug_dtf_builder);
      } catch (error) {
        throw new Error('BOGO Gang Sheet production data is invalid.');
      }
      if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
        throw new Error('BOGO Gang Sheet production data is missing.');
      }

      payload.production = {
        offer: 'buy_1_get_1_identical',
        sheetCount: 2,
        paidSheetCount: 1,
        freeSheetCount: 1,
        identicalSheets: true
      };
      properties._zug_dtf_builder = JSON.stringify(payload);
    } else if (!properties._zug_dtf_job_id) {
      throw new Error('BOGO Gang Sheet production data is missing.');
    }

    properties._dtf_bogo_offer = 'buy_1_get_1_identical';
    properties._dtf_paid_sheet_quantity = '1';
    properties._dtf_free_sheet_quantity = '1';
    properties._dtf_production_sheet_quantity = '2';
    properties['Production Quantity'] = '2 identical sheets (1 paid + 1 free)';
  }

  function buildLine(input) {
    input = input || {};
    var length = validLength(input.lengthIn);
    var bogo = input.bogo === true;
    var quantity = bogo ? 1 : positiveInteger(input.quantity);
    var entry = resolveVariant(input.map, input.lengthIn);
    var properties = stripLegacyMarkers(Object.assign({}, input.properties || {}));
    var sizeLabel = optionValue(length);
    var uid = String(input.uid || createUid()).trim();

    if (!quantity || !uid) throw new Error('Gang Sheet native cart input is incomplete.');
    if (String(properties['Gang Sheet Size'] || '').trim() !== sizeLabel) {
      throw new Error('Gang Sheet builder size does not match the approved native variant.');
    }
    if (!properties._zug_dtf_handoff || !(properties._zug_dtf_builder || properties._zug_dtf_job_id)) {
      throw new Error('Gang Sheet builder handoff is missing.');
    }
    if (bogo) addBogoProductionMetadata(properties);

    properties._product_family = 'dtf';
    properties._gang_sheet_native_contract = CONTRACT;
    properties._gang_sheet_native_uid = uid;
    properties._gang_sheet_native_length = String(length);
    properties._gang_sheet_native_variant_sku = entry.sku;

    return {
      uid: uid,
      bogo: bogo,
      lengthIn: length,
      sizeLabel: sizeLabel,
      quantity: quantity,
      priceCents: Number(entry.priceCents),
      targetTotalCents: Number(entry.priceCents) * quantity,
      variant: entry,
      item: {
        id: Number(entry.variantId),
        quantity: quantity,
        properties: properties
      }
    };
  }

  function lineProperties(line) {
    return line && line.properties ? line.properties : {};
  }

  function verifyCart(cart, spec, options) {
    cart = cart || {};
    spec = spec || {};
    options = options || {};
    var errors = [];
    var lines = (Array.isArray(cart.items) ? cart.items : []).filter(function (line) {
      return String(lineProperties(line)._gang_sheet_native_uid || '') === String(spec.uid || '');
    });
    var line = lines[0];
    var properties = lineProperties(line);
    var unitPrice = Number(line && (line.original_price != null ? line.original_price : line.price));
    var linePrice = Number(line && (line.original_line_price != null ? line.original_line_price : line.line_price));

    if (lines.length !== 1) errors.push('expected exactly one Gang Sheet merchandise line');
    if (!line || Number(line.variant_id || line.id) !== Number(spec.variant && spec.variant.variantId)) {
      errors.push('Gang Sheet native variant does not match');
    }
    if (!line || Number(line.quantity) !== Number(spec.quantity)) errors.push('Gang Sheet quantity does not match');
    if (!line || line.requires_shipping !== true) errors.push('Gang Sheet line is not shipping-required');
    if (!Number.isInteger(unitPrice) || unitPrice !== Number(spec.priceCents)) {
      errors.push('Gang Sheet native unit price does not match');
    }
    if (!Number.isInteger(linePrice) || linePrice !== Number(spec.targetTotalCents)) {
      errors.push('Gang Sheet native extended price does not match');
    }
    if (String(properties['Gang Sheet Size'] || '').trim() !== String(spec.sizeLabel || '')) {
      errors.push('Gang Sheet Size property does not match');
    }
    if (properties._gang_sheet_native_contract !== CONTRACT ||
        properties._gang_sheet_native_variant_sku !== String(spec.variant && spec.variant.sku || '') ||
        Number(properties._gang_sheet_native_length) !== Number(spec.lengthIn)) {
      errors.push('Gang Sheet native line metadata does not match');
    }
    if (options.requireBuilderPayload !== false &&
        (!properties._zug_dtf_handoff || !(properties._zug_dtf_builder || properties._zug_dtf_job_id))) {
      errors.push('Gang Sheet builder payload was not retained');
    }
    if (spec.bogo) {
      var productionPayload;
      try {
        productionPayload = JSON.parse(properties._zug_dtf_builder || '');
      } catch (error) {
        productionPayload = null;
      }
      var production = productionPayload && productionPayload.production;
      if (Number(line && line.quantity) !== 1 ||
          properties._dtf_bogo_offer !== 'buy_1_get_1_identical' ||
          properties._dtf_paid_sheet_quantity !== '1' ||
          properties._dtf_free_sheet_quantity !== '1' ||
          properties._dtf_production_sheet_quantity !== '2' ||
          properties['Production Quantity'] !== '2 identical sheets (1 paid + 1 free)' ||
          (properties._zug_dtf_builder && (!production || production.offer !== 'buy_1_get_1_identical' ||
            Number(production.sheetCount) !== 2 || Number(production.paidSheetCount) !== 1 ||
            Number(production.freeSheetCount) !== 1 || production.identicalSheets !== true))) {
        errors.push('BOGO Gang Sheet production quantity does not describe one paid and one identical free sheet');
      }
    }
    LEGACY_MARKERS.forEach(function (key) {
      if (properties[key] != null && properties[key] !== '') {
        errors.push('legacy Gang Sheet carrier marker leaked: ' + key);
      }
    });

    return {
      valid: errors.length === 0,
      errors: errors,
      lines: lines,
      line: line || null,
      totalCents: linePrice
    };
  }

  function responseError(response, fallback) {
    return response.json().catch(function () { return {}; }).then(function (payload) {
      throw new Error(payload.description || payload.message || fallback);
    });
  }

  function rollbackUid(fetchImpl, uid) {
    return fetchImpl('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Gang Sheet rollback cart read-back failed.');
        return response.json();
      })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (line) {
          if (String(lineProperties(line)._gang_sheet_native_uid || '') === String(uid || '')) {
            updates[line.key] = 0;
          }
        });
        if (Object.keys(updates).length === 0) return cart;
        return fetchImpl('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function (response) {
          if (!response.ok) throw new Error('Gang Sheet rollback failed.');
          return response.json();
        });
      });
  }

  function addVerifiedLine(input) {
    input = input || {};
    var fetchImpl = input.fetch;
    var spec = input.spec;
    if (typeof fetchImpl !== 'function' || !spec || !spec.item) {
      return Promise.reject(new Error('Gang Sheet verified native submission is incomplete.'));
    }

    return fetchImpl('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [spec.item] })
    }).then(function (response) {
      if (!response.ok) return responseError(response, 'Gang Sheet native cart add failed.');
      return response.json();
    }).then(function (addResponse) {
      return fetchImpl('/cart.js', { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Gang Sheet native cart read-back failed.');
        return response.json();
      }).then(function (cart) {
        var verification = verifyCart(cart, spec, input);
        if (!verification.valid) {
          throw new Error('Gang Sheet native cart verification failed: ' + verification.errors.join('; '));
        }
        return { addResponse: addResponse, cart: cart, spec: spec, verification: verification };
      }).catch(function (error) {
        return rollbackUid(fetchImpl, spec.uid).then(function () {
          throw error;
        }, function () {
          throw error;
        });
      });
    });
  }

  return {
    CONTRACT: CONTRACT,
    createUid: createUid,
    validLength: validLength,
    pricePerSqIn: pricePerSqIn,
    priceCents: priceCents,
    optionValue: optionValue,
    sku: sku,
    validateMap: validateMap,
    resolveVariant: resolveVariant,
    stripLegacyMarkers: stripLegacyMarkers,
    buildLine: buildLine,
    verifyCart: verifyCart,
    rollbackUid: rollbackUid,
    addVerifiedLine: addVerifiedLine,
    positiveInteger: positiveInteger
  };
});
